import React, { useContext, useEffect, useState } from "react";
import { useCartInventoryContext } from "../../../Context/Cache/CartInventoryContext";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import { useCartAccountContext } from "../../../Context/Cache/CartAccount/CartAccountContext";
import { VerificationLoadingScreen } from "../../LoadingScreen";
import VerificationPopup from "./VerificationPopup";
const CartDetails = () => {
  const {
    handleGenerateQuote,
    cartNotification,
    setCartNotification,
    cartProduct, setOwnerInfo,
    fetchDataFromUserCache
  } = useCartInventoryContext();
  const { accountDetails } = useCartAccountContext()
  // Set Account Id
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const { totalPrice, totalMSRP } = useCartInventoryContext();
  const [showData, setShowData] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isVerify, setIsVerify] = useState(false)
  const [modalMessages, setModalMessages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const hasCartProducts = cartProduct && cartProduct.length > 0;
  // Retrieve values from local storage
  const isValidNewCustomer =
    localStorage.getItem("validNewCustomer") === "true";
  const isValidExistingCustomer =
    localStorage.getItem("validWithOTP") === "true";
  const isValidSalesPerson =
    localStorage.getItem("validSalesPerson") === "true";
  let newcustomerlogin = localStorage.getItem("newCustomer") === "true";

  const checkAndStoreUserData = () => {
    // Parse the `userData` from `sessionStorage`
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const validSalesPerson = localStorage.getItem('validSalesPerson') === 'true';
    const validNewUser = localStorage.getItem('newCustomer') === 'true';

    // Check if `userData` exists
    if (userData) {
      if (!validSalesPerson && validNewUser) {
        // Store `contactId` and `accountId` in `sessionStorage`
        sessionStorage.setItem('contactId', userData.contactId);
        sessionStorage.setItem('accountId', userData.accountId);
        setOwnerInfo(accountDetails)
        console.log('Contact ID and Account ID stored in sessionStorage');
      } else {
        console.log('Conditions not met. Data not stored.');
      }
    } else {
      console.log('UserData does not exist in sessionStorage');
    }
  };

  // If 'newcustomer' is not in localstorage, set 'newcustomerlogin' to false
  if (newcustomerlogin === null) {
    newcustomerlogin = false;
  }

  useEffect(() => {
    const fetchData = async () => {
      if (newcustomerlogin) {
        checkAndStoreUserData();
        // await fetchNewAccountNames();
      }
    };

    fetchData().catch((error) =>
      console.error("Error fetching data:", error)
    );
  }, [accountDetails]);


  // Existing Customer
  useEffect(() => {
    const fetchData = async (accountDetails) => {
      setShowData(accountDetails);
    }
    fetchData(accountDetails)
  }, [accountDetails])

  //automatically fill for the New Customer
  useEffect(() => {
    if (newcustomerlogin && showData.length > 0) {
      setSelectedCustomer(showData[0]);
    }
  }, [newcustomerlogin, showData]);

  // Function to place Order and also see Ripple effect while clicking on the button
  const createRipple = (event) => {
    const button = event.currentTarget;
    const ripple = document.createElement("span");

    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    ripple.style.top = `${event.clientY - button.offsetTop - radius}px`;
    ripple.classList.add("ripple");

    // Remove any existing ripples
    const rippleContainer = button.getElementsByClassName("ripple")[0];
    if (rippleContainer) {
      rippleContainer.remove();
    }

    additionalFunction();
  };

  // Function to Add Commas to format Number
  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // Funtion to formatCurrency
  function formatNumber(number) {
    if (isNaN(number) || number === null || number === undefined) {
      number = 0;
    }
    const formattedNumber = Number(number).toFixed(2);
    return formatNumberWithCommas(formattedNumber);
  }

  // Function to check that Account is selected or not if yes then call the handleGenerateQuote function
  const additionalFunction = () => {
    if (!selectedCustomer || !selectedCustomer.value) {
      toast.error("Please select an account before placing an order.");
      return;
    }
    console.log("Additional function called!");
    // handleGenerateQuote();
    cartData()
  };

  // const cartData = () => {
  //   const cartProductData = cartProduct.map((product) => ({
  //     productid: product.productid,
  //     productnumber: product.productnumber,
  //     requestedQuantity: product.requestedQuantity,
  //     incoming: product.incoming
  //   }));
  //   console.log("Cart Data", cartProduct)
  //   console.log("User Cart Data", cartProductData);
  // };

  const cartData = async () => {
    setIsVerify(true);

    const cartProductData = cartProduct.map((product) => ({
      productid: product.productid,
      productnumber: product.productnumber,
      requestedQuantity: product.requestedQuantity,
      incoming: product.incoming || false,
    }));

    try {

      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/data/validate-cart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ products: cartProductData }),
      })


      // const response = await fetch(process.env.REACT_APP_PRODUCT_VERIFICATION_FLOW_URL, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify({ products: cartProductData }),
      // });

      const result = await response.json();
      console.log("Validate Cart response:", result);

      // Collect all non-valid messages for the modal
      const messages = [];
      result.outcomes.forEach((product) => {
        if (product.status !== "valid") {
          setIsVerify(false);
          messages.push(product.message);
        }
      });
      if (messages.length > 0) {
        setModalMessages(messages);
        setShowModal(true);
      }
      if (result.allValid) {
        setIsVerify(false);
        handleGenerateQuote();
      }
    } catch (error) {
      setIsVerify(false);
      console.error("Error sending data to Power Automate:", error);
    }
  };



  // const cartData = async () => {
  //   setIsVerify(true)
  //   const cartProductData = cartProduct.map((product) => ({
  //     productid: product.productid,
  //     productnumber: product.productnumber,
  //     requestedQuantity: product.requestedQuantity,
  //     incoming: product.incoming || false
  //   }));
  //   try {
  //     const response = await fetch(process.env.REACT_APP_PRODUCT_VERIFICATION_FLOW_URL, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ products: cartProductData }),
  //     });
  //     const result = await response.json();
  //     console.log("Power Automate Response:", result);
  //     // Handle individual product outcomes
  //     result.outcomes.forEach((product) => {
  //       if (product.status !== "valid") {
  //           setIsVerify(false);
  //           toast.warning(`${product.message}`);
  //       }
  //   });    
  //     if (result.allValid) {
  //       setIsVerify(false)
  //       // handleGenerateQuote();
  //     }
  //   } catch (error) {
  //     setIsVerify(false)
  //     console.error("Error sending data to Power Automate:", error);
  //   }
  // };

  
  
  useEffect(() => {
    if (cartNotification != null) {
      console.log("cart toast");
      toast.error(cartNotification);
      setCartNotification(null);
    }
  }, [cartNotification]);

  // Function to change Account and store that in the session Storage
  const handleAccountChange = async (selectedOption) => {
    // await handleFetchOwnerInfo(selectedOption); // Pass the selectedOption to the function
    setOwnerInfo(selectedOption)
    setSelectedCustomer(selectedOption);
    sessionStorage.setItem("accountId", selectedOption.value);
  };

  return (
    <div className="col-lg-3 order-2 order-lg-1 nycfix-child-one">
      <ToastContainer />
      {isVerify && <VerificationLoadingScreen />}
      {/* {isLoading && <LoadingScreen />} */}
      <div className="shop-sidebar-wrap mt-md-28 mt-sm-28">
        <div className="flex flex-col gap-1">
          <div>
            {isValidNewCustomer && isValidExistingCustomer && isValidSalesPerson ? (
              <h1 className="font-bold p-2 text-md bg-white">
                Select Customer:
                <span className="text-red-700 font-semibold text-xl">*</span>
              </h1>
            ) : newcustomerlogin ? (
              <h1 className="font-bold p-2 text-md bg-white">
                Account Name:
                <span className="text-red-700 font-semibold text-xl">*</span>
              </h1>
            ) : (
              <label className="font-semibold p-2 text-md mb-2 block bg-white">
                Select Your Account:
                <span className="text-red-700 font-semibold text-xl">*</span>
              </label>
            )}
            <Select
              options={showData}
              value={selectedCustomer}
              onChange={handleAccountChange}
              name="customer"
              isSearchable
            />
          </div>
          {cartProduct[0].nyc_atuid != undefined ? null :
            <div className="bg-white p-2 py-3">
              <p className="flex justify-between">
                <span className="font-semibold">Total MSRP</span>
                <span className="font-semibold text-lg">
                  {/* ${(totalMSRP || 0).toFixed(2)} */}
                  ${formatNumber(totalMSRP)}
                </span>
              </p>
              {/* <p className="flex justify-between">
          <span>Discount on MRP</span>
          <span>$ 26.00</span>
        </p> */}
            </div>}
          <div className="bg-white p-2 py-3">
            <p className="flex justify-between">
              <span className="font-semibold">Total Price</span>
              <span className="font-semibold text-lg">
                {/* ${(totalPrice || 0).toFixed(2)} */}
                ${formatNumber(totalPrice)}
              </span>
            </p>
          </div>
          <div className="bg-white p-2">
            <button
              className={`placeOrderbtn ${buttonLoading ? "grayButton" : ""}`}
              onClick={createRipple}
              disabled={!selectedCustomer || buttonLoading} // Disable if no customer selected or if loading
            >
              {buttonLoading ? "Please wait..." : "Place Offer"}
            </button>
          </div>
        </div>
      </div>
      {showModal && (
        <VerificationPopup
          messages={modalMessages}
          onClose={() => setShowModal(false)} // Close the modal on "OK"
        />
      )}
    </div>
  );
};

export default CartDetails;